import React from "react";
import Applet from "../../Applet";
import AdminRoleTable from "../../../../components/Administration/AdminRoleTable";

class AdminRoleTableApplet extends Applet {

    render() {
        return <AdminRoleTable applet={this}
                               pageSize={this.state.PageSize}
                               placement={this.state.Placement}
                               columns={this.state.Columns}
                               title="Roles"
                               enterpriseComponent={this.getEnterpriseComponent()}
                               sort={this.state.Sort}
                               menu={this.state.Menu}
                               rowHeight={this.state.RowHeight}
                               simpleSearch={this.state.SimpleSearch}
        />;
    }

    state = {
        Name: "AdminRoleTableApplet",
        Menu: {
            options: [
                {
                    displayValue: "New Role",
                    value: "New Role",
                },
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                }
            ]
        },
        RowHeight: 60,
        PageSize: {
            "default": 20,
            "xs": 3,
            "sm": 3,
            "md": 20,
            "lg": 20,
            "lx": 20,
        },
        Placement: {
            "xl": [
                {
                    id: "RecordPointer",
                },
                {
                    id: "Name",
                },
                {
                    id: "Status"
                },
                {
                    id: "Actions",
                },
            ],
        },
        Columns: [
            {
                id: "RecordPointer",
                width: 25,
                cellRenderer: "Row Selection Indicator Cell",
                header: null,
                headerRenderer: "",
                headerTitle: "",
            },
            {
                id: "Name",
                width: 325,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Name",
            },
            {
                id: "Status",
                width: 300,
                cellRenderer: "Status Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Status",
            },
            {
                id: "Actions",
                width: 50,
                cellRenderer: "Action Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "",
                pinned: "right",
                hideable: false,
            }
        ],
        Sort: [
            {
                "Identifier": 1,
                "Visible": true,
                "Default": true,
                "Options": [{
                    "Direction": "ASC",
                    "SortAttribute": "Name",
                    "DisplayName": "Name",
                }],
            },
        ],
        SimpleSearch: {
            Actions: {
                Query: {
                    Groups: [
                        {
                            "identifier": "group1",
                            "type": "standard",
                            "selector": null,
                            "characteristics": [],
                            "membership": [
                                {
                                    id: "Name",
                                },
                                {
                                    id: "Status",
                                },
                                {
                                    id: "CreatedDatetime",
                                }
                            ]
                        }
                    ]
                }
            },
            Controls: {
                "Name": {
                    id: "Name",
                    enterpriseComponentAttribute: "Name",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 6,
                            md: 6,
                            lg: 3,
                            xl: 3
                        }
                    },
                    errors: [
                        {
                            validator: "No Special Characters",
                            value: null,
                            errorText: "Field must not have special characters.",
                        },
                        {
                            validator: "No Leading Spaces",
                            value: null,
                            errorText: "Field must not have leading spaces.",
                        },
                        {
                            validator: "Not All Spaces",
                            value: null,
                            errorText: "Field must not have all spaces.",
                        },

                    ],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "Name",
                        disabled: false,
                        size: "small"
                    },
                    ip: {},
                    type: "TextField",
                    requiresConfirmation: false,
                },
                "Status": {
                    id: "Status",
                    enterpriseComponentAttribute: "Status",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 6,
                            md: 6,
                            lg: 3,
                            xl: 3
                        }
                    },
                    errors: [],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "Status",
                        disabled: false,
                        size: "small"
                    },
                    ip: {},
                    type: "Select",
                    requiresConfirmation: false,
                },
                "CreatedDatetime": {
                    id: "CreatedDatetime",
                    enterpriseComponentAttribute: "CreatedDatetime",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 6,
                            md: 6,
                            lg: 3,
                            xl: 3
                        }
                    },
                    errors: [],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "Created On",
                        disabled: false,
                        size: "small"
                    },
                    ip: {},
                    type: "DateTime",
                    requiresConfirmation: false,
                }
            }
        }
    }
}

export default AdminRoleTableApplet;
